import AssignmentIcon from "@material-ui/icons/Assignment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";

export default function TaskModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/tasks");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<AssignmentIcon />}
      header={t("tasks.header")}
    />
  );
}
